// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"eecd8225","261":"12cfdebe","404":"0d48d869","538":"53191503","566":"ec1685e5","826":"960271e0"}[chunkId] + ".chunk.js";
};